import { LAYOUTS } from "@voltmoney/types";
import { ROUTE } from "../../routes";
import { WIDGET } from "@voltmoney/schema";
import { ACTION } from "./types";
import { goBack, openBajajLink, openBajajLoanAgainstMutualFundsLink, openDSPLink, openTclLink } from "./action";
import { showDspContent } from "../../configs/utils";
export const template = (height, showDspContentForAllCustomer) => {
    return {
        layout: {
            id: ROUTE.LENDING_PARTNER_PAGE_MF,
            type: LAYOUTS.LIST,
            style: {
                isPartnerPlatform: true
            },
            widgets: [{
                    id: 'lendingPartnerScreen',
                    type: WIDGET.LENDING_PARTNER_SCREEN_DC,
                }],
        },
        datastore: {
            lendingPartnerScreen: {
                height,
                showDspContentForAllCustomer,
                tclAction: {
                    payload: {},
                    type: ACTION.OPEN_TCL,
                    routeId: ROUTE.LENDING_PARTNER_PAGE_MF,
                },
                bajajAction: {
                    payload: {},
                    type: ACTION.OPEN_BAJAJ_FIN,
                    routeId: ROUTE.LENDING_PARTNER_PAGE_MF,
                },
                backAction: {
                    payload: {},
                    type: ACTION.GO_BACK,
                    routeId: ROUTE.LENDING_PARTNER_PAGE_MF,
                },
                dspAction: {
                    payload: {},
                    type: ACTION.OPEN_DSP_LINK,
                    routeId: ROUTE.LENDING_PARTNER_PAGE_MF,
                },
                openBajajLoanAgainstMutualFundsLink: {
                    payload: {},
                    type: ACTION.OPEN_BAJAJ_LOAN_AGAINST_MUTUAL_FUNDS_LINK,
                    routeId: ROUTE.LENDING_PARTNER_PAGE_MF,
                }
            }
        },
    };
};
export const LendingPartnerPage = {
    onLoad: async ({ getHeight }) => {
        const showDspContentForAllCustomer = await showDspContent();
        return Promise.resolve(template(getHeight(), showDspContentForAllCustomer));
    },
    actions: {
        [ACTION.GO_BACK]: goBack,
        [ACTION.OPEN_TCL]: openTclLink,
        [ACTION.OPEN_BAJAJ_FIN]: openBajajLink,
        [ACTION.OPEN_DSP_LINK]: openDSPLink,
        [ACTION.OPEN_BAJAJ_LOAN_AGAINST_MUTUAL_FUNDS_LINK]: openBajajLoanAgainstMutualFundsLink,
    },
};
